export default {
  reprintTitle: 'RFID Reprint',
  printSetting: 'Printer settings',
  macAddressSN: 'Mac Address/SN',
  printerIP: 'Printer IP',
  placehilderIp: 'For example: 192.168.0.101',
  site: 'Site',
  printSettingSuccess: 'Request Successfully, PLS check in printer.',
  ipFormat: 'Incorrect Printer IP Address Format.',
  printerSuccess: 'Request Successfully, PLS check in printer.',
  clearNextScan: 'Clear is required before next scan.',
  back: 'Back',
  print: 'Print',
  errorcode_435: `Invalid UPC format, please try again. Correct UPC format should be 00197863493015.`,
  errorcode_436: 'Request Error, PLS try again.',
  errorcode_5601: `Invalid QR Code format, please try again. Correct QR Code format should be HTTPS://QR.NIKE.COM/04B5Z1S0ERWR1.`,
  errorcode_5602: `Invalid QR Code. Please scan product UPC to print.`,
  errorcode_5603: 'Request Error, PLS try again.',
  errorcode_5604: 'UPC Unmatched.',
  notConnection: 'Printer connection Failed, PLS check network/printer connection.',
  errorcode_6001: 'Printer connection Failed, PLS check network/printer connection.',
  errorcode_6002: 'Printer connection Failed, PLS check network/printer connection.',
  errorcode_6003: 'Connection Error.',
  errorcode_7008: 'EPC already bound. Please relabel via UPC scan.',
  printerIpPlantMismatch: 'Printer IP address and Site/Plant Code Unmatched!',
  errorcodeNoInput: 'Please input Printer IP address/Site to continue.',
  placeholderQr: 'QR Code Cannot Input',
  inputTip: 'Please Click "Enter" after Input Value',
  rifdSkuCheck: 'RFID SKU Check',
  checkTitle: 'Please scan the product RFID EPC or QR Code:',
  checkPlaceholder: 'Scan automatic recognition',
  scanResult: 'Scan Result',
  division: 'Division',
  switchToQrCode: 'Switch To QR Code',
  switchToRfidEpc: 'Switch To RFID EPC',
  errorcode_check_436: 'Request Error, PLS try again.',
  errorcode_check_8001: 'Invalid data format, please try again. Correct EPC format should be 30340C13A0436B070931F406.',
  errorcode_check_8002:
    'Invalid data format, please try again. Correct QR Code format should be HTTPS://QR.NIKE.COM/04B5Z1S0ERWR1.',
  errorcode_check_7004: 'The QR Code cannot be decoded into UPC. Please scan the EPC.',
  errorcode_check_30011: 'The EPC cannot be decoded into UPC. Please scan the QR Code.',
  placehilderTipEpc: 'Please scan the product RIFD EPC',
  placehilderTipQrCode: 'Please scan the product QR Code',
  settingTip1: `Please make sure to confirm the printing driver Zebra Browser
                Print is currently running normally; If the installation has not been completed yet,
                you need to download and complete the installation first, and then enter the configuration interface,
                Locate the system tray icon in the bottom right corner and operate it by selecting the "Settings" option from the right-click menu.`,
  settingTip2: `When configuring a printing device, it is necessary to enter the device name and corresponding printer IP address,
                and then click "Add" to complete the device addition; Then,
                Click on the 'Change' option to set the device as the default printer. After the above operation is completed, refresh the page to take effect.`,
  settingTip3: `The first time entering the system requires authorization to use.`,
  settingStep1: `Step 1`,
  settingStep2: `Step 2`,
  settingStep3: `Step 3`,
  settingStep4: `Step 4`,
  settingDown: `Download link`,
  settingTour: `Set up guidance`,
  settingSeeTour: `View Settings Guide`
}
